import React from 'react'
import PropTypes from 'prop-types'

import styles from './index.module.scss'

const FormSection = ({ title, description = '', children }) => {
	return (
		<div className={styles.container}>
			<div className={styles.formSectionHeader}>
				<h4 className={styles.title}>{title}</h4>
				<p className={styles.description}>{description}</p>
			</div>
			{children && <div className={styles.formFields}>{children}</div>}
		</div>
	)
}

FormSection.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
}

export default FormSection
